import { render } from "./IconChat.vue?vue&type=template&id=44c664f9&ts=true"
import script from "./IconChat.vue?vue&type=script&lang=ts"
export * from "./IconChat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__